import { combineReducers } from "redux";
import getReadOnlyReducer from "./readOnlyReducer";

const readOnlyReducer = combineReducers({
    readOnly: getReadOnlyReducer,
});

export default readOnlyReducer;